/**
 * 게임 상태 관련 유틸리티
 */
/**
 * 상태 복사 (깊은 복사)
 */
export function cloneState(state) {
    return JSON.parse(JSON.stringify(state));
}
/**
 * 상태 동결 (readonly 적용)
 */
export function freezeState(state) {
    return Object.freeze(cloneState(state));
}
/**
 * 상태 히스토리 (디버깅/리플레이용)
 */
export class StateHistory {
    constructor(maxSize = 100) {
        this.snapshots = [];
        this.maxSize = maxSize;
    }
    /**
     * 스냅샷 추가
     */
    push(state, actionType) {
        this.snapshots.push({
            state: cloneState(state),
            timestamp: Date.now(),
            actionType
        });
        if (this.snapshots.length > this.maxSize) {
            this.snapshots.shift();
        }
    }
    /**
     * 특정 인덱스의 스냅샷 가져오기
     */
    get(index) {
        return this.snapshots[index];
    }
    /**
     * 마지막 스냅샷
     */
    getLast() {
        return this.snapshots[this.snapshots.length - 1];
    }
    /**
     * 전체 히스토리
     */
    getAll() {
        return this.snapshots;
    }
    /**
     * 히스토리 크기
     */
    get size() {
        return this.snapshots.length;
    }
    /**
     * 히스토리 초기화
     */
    clear() {
        this.snapshots = [];
    }
}
//# sourceMappingURL=GameState.js.map